import { useClipboard } from './use-clipboard';

export type LinkShareResult = 'cancelled' | 'copied' | 'shared' | 'unavailable';

function isAbortShareError(error: unknown) {
  return error instanceof Error && error.name === 'AbortError';
}

export function useLinkShareActions(link: string | null) {
  const clipboard = useClipboard();

  const copyLink = async () => {
    if (!link) {
      return false;
    }

    return clipboard.writeText(link);
  };

  const shareLink = async (): Promise<LinkShareResult> => {
    if (!link) {
      return 'unavailable';
    }

    if (
      typeof navigator !== 'undefined' &&
      typeof navigator.share === 'function'
    ) {
      try {
        if (
          typeof navigator.canShare !== 'function' ||
          navigator.canShare({ url: link })
        ) {
          await navigator.share({ url: link });
          return 'shared';
        }
      } catch (error) {
        if (isAbortShareError(error)) {
          return 'cancelled';
        }
      }
    }

    const isCopied = await copyLink();

    return isCopied ? 'copied' : 'unavailable';
  };

  return {
    copyLink,
    shareLink,
  };
}
